import React, {useState, useEffect} from 'react';
import axios from "axios";
import { Tile } from "./Tile";
import { TileBig } from "./TileBig";
import {Alert, Container, Form, Row, InputGroup, Button} from "react-bootstrap";
import * as Scroll from 'react-scroll';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons'

import {useTranslation} from "react-i18next";

export const App = () => {

    //Setup
    const [systemReady, setSystemReady] = useState(false);
    const [currSuffix, setCurrSuffix] = useState('');
    const [currLocale, setCurrLocale] = useState('');

    //Complete List
    const [navigatorInputs, setNavigatorInputs] = useState([]);

    //Individuall Settings
    const [iFrameResizer, setIFrameResizer] = useState(0);
    const [currentSubfloorID, setCurrentSubfloorID] = useState(-1);
    const [currentSubfloorCatID, setCurrentSubfloorCatID] = useState(-1);
    const [currentCoveringID, setCurrentCoveringID] = useState(-1);
    const [currentCoveringCatID, setCurrentCoveringCatID] = useState(-1);
    const [currentOptionID, setCurrentOptionID] = useState(-1);
    const [currentArea, setCurrentArea] = useState(100);
    const [currentfiller, setCurrentFilller] = useState(1);

    const [currentOutput, setCurrentOutput] = useState("");
    const [currentOutputExclude, setCurrentOutputExclude] = useState(false);

    //Subfloor filtering
    const subfloorCategories = navigatorInputs.filter(inputElement => (inputElement.input_id === "1" && inputElement.parent_id === "0"));
    const [subfloorItems, setSubfloorItems] = useState([]);
    const [subfloorItemsCount, setSubfloorItemsCount] = useState([]);

    //Covering filtering
    const coveringCategories = navigatorInputs.filter(inputElement => (inputElement.input_id === "2" && inputElement.parent_id === "0"));
    const [coveringItems, setCoveringItems] = useState([]);
    const [coveringItemsCount, setCoveringItemsCount] = useState([]);

    var scroll    = Scroll.animateScroll;
    const {t, i18n} = useTranslation();

    //Load live data from API
    useEffect(() => {
        document.title = t('Bodennavigator');

        if( iFrameResizer === 0 ) {
            //console.log('Init Resizer');
            setIFrameResizer(1);
            iframeResize();
        }

        console.log('UZIN UTZ SE - Floornavigator');

        if( !systemReady ) {
            setSystemReady(true);
            //console.log('--Init')
            initSystem();
        }
    });

    async function initSystem() {
        //check for special suffix
        let queryParameters = new URLSearchParams(window.location.search)
        let currSuffix = process.env.REACT_APP_API_SUFFIX;
        let currLocale = process.env.REACT_APP_API_LOCALE;

        if( queryParameters.get("suffix") && queryParameters.get("suffix") !== "" ) {
            currSuffix = queryParameters.get("suffix");
        }
        if( queryParameters.get("locale") && queryParameters.get("locale") !== "" ) {
            currLocale = queryParameters.get("locale");
        }

        setCurrSuffix(currSuffix);
        console.log('Suffix: ' + currSuffix);
        setCurrLocale(currLocale);
        i18n.changeLanguage(currLocale)
        console.log('Locale: ' + currLocale + ' -> ' + i18n.language);



        document.title = t('Bodennavigator') + ' (' + currLocale+' | '+currSuffix+')';

        if( navigatorInputs.length === 0 ) {
            await axios.get( process.env.REACT_APP_BASEURL + process.env.REACT_APP_API_ENDPOINT_INPUTS, {
                headers: {
                    //'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                params: {
                    locale: currLocale,
                    suffix: currSuffix,
                }
            }).then((response) => {
                setNavigatorInputs(response.data);

                //calculate Sub filters
                var itemsTemp = response.data.filter(inputElement => (inputElement.input_id === "1" && parseInt(inputElement.parent_id) !== 0));
                setSubfloorItems(itemsTemp);
                setSubfloorItemsCount(itemsTemp.length);

                itemsTemp = response.data.filter(inputElement => (inputElement.input_id === "2" && parseInt(inputElement.parent_id) !== 0));
                setCoveringItems(itemsTemp);
                setCoveringItemsCount(itemsTemp.length);
            }).catch(function (error) {
				if (error.response) {
				  // The request was made and the server responded with a status code
				  // that falls out of the range of 2xx
				  
				  console.log("[==== ERROR IN RESPONSE ====]");
				  console.log(error.response.data);
				  console.log(error.response.status);
				  console.log(error.response.headers);
				  
				  console.log('REACT_APP_BASEURL: ' + process.env.REACT_APP_BASEURL);
				  console.log('REACT_APP_API_ENDPOINT_INPUTS: ' + process.env.REACT_APP_API_ENDPOINT_INPUTS);
				  
				  console.log(process.env);
				} else if (error.request) {
				  // The request was made but no response was received
				  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				  // http.ClientRequest in node.js
				  console.log(error.request);
				  
				  console.log('REACT_APP_BASEURL: ' + process.env.REACT_APP_BASEURL);
				  console.log('REACT_APP_API_ENDPOINT_INPUTS: ' + process.env.REACT_APP_API_ENDPOINT_INPUTS);
				} else {
				  // Something happened in setting up the request that triggered an Error
				  console.log('Error', error.message);
				  
				  console.log('REACT_APP_BASEURL: ' + process.env.REACT_APP_BASEURL);
				  console.log('REACT_APP_API_ENDPOINT_INPUTS: ' + process.env.REACT_APP_API_ENDPOINT_INPUTS);
				}
				console.log(error.config);
			});
        }
    }

    function selectSubfloorCat( value ) {
        //reset child element and step 2
        setCurrentOutputExclude(false);
        setCurrentSubfloorID(-1);
        setCurrentCoveringCatID(-1);
        setCurrentCoveringID(-1);
        setCurrentOptionID(-1)
        //set this element
        setCurrentSubfloorCatID(value);
        setCurrentOutput("");

        //filter subitems
        if( value !== -1 ) {
            setSubfloorItems(navigatorInputs.filter(inputElement => (inputElement.input_id === "1" && parseInt(inputElement.parent_id) === value)));
        } else {
            setSubfloorItems(navigatorInputs.filter(inputElement => (inputElement.input_id === "1" && parseInt(inputElement.parent_id) !== 0)));
        }

        //scroll down
        scrollFrame(['contUntergrund', 'uu-cards-undercat']);
    }

    function selectSubfloorID( value ) {
        setCurrentSubfloorID(value);
        setCurrentOutput("");
        setCurrentOutputExclude(false);

        //scroll down
        scrollFrame(['contBelagCat','uu-cards-under']);
    }

    function selectCoveringCat( value ) {
        //reset child element
        setCurrentCoveringID(-1);
        setCurrentOptionID(-1)
        setCurrentOutputExclude(false);
        //set this element
        setCurrentCoveringCatID(value);
        setCurrentOutput("");

        //filter subitems
        if( value !== -1 ) {
            setCoveringItems(navigatorInputs.filter(inputElement => (inputElement.input_id === "2" && parseInt(inputElement.parent_id) === value)));
        } else {
            setCoveringItems(navigatorInputs.filter(inputElement => (inputElement.input_id === "2" && parseInt(inputElement.parent_id) !== 0)));
        }

        scrollFrame(['contBelag','uu-cards-floorcat']);
    }

    function selectCoveringID( value ) {
        setCurrentCoveringID(value);
        setCurrentOutput("");
        setCurrentOutputExclude(false);

        scrollFrame(['contOptions','uu-cards-floor']);
    }

    function resetInputValues( value, type ) {
        if( type === 'area' ) {
            if( currentArea !== value ) {
                setCurrentArea(value);
                setCurrentOutput("");
                setCurrentOutputExclude(false);
            }
        } else if ( type === 'thikness' ) {
            if( value > 10 ) {
                value = 10;
            }
            if( currentfiller !== value ) {
                setCurrentFilller(value);
                setCurrentOutput("");
                setCurrentOutputExclude(false);
            }
        }
    }

    function resetOption( value ) {
        setCurrentOptionID( value );
        setCurrentOutput("");
        setCurrentOutputExclude(false);

        scrollFrame(['contCreate','uu-cards-options']);
    }

    function onsubmit( mode = 'html' ) {

        if( currentfiller > 10 ) {
            setCurrentFilller(10);
        }

        //check exclude
        let thisSubfloor = subfloorItems.filter(inputElement => (parseInt(inputElement.id) === currentSubfloorID));

        if( thisSubfloor && thisSubfloor[0] && thisSubfloor[0].exclude && thisSubfloor[0].exclude.some(item => currentCoveringID === item) ) {

            setCurrentOutputExclude(true);
            scrollFrame(['contInfo', 'inputsSet']);

        } else {



            if( mode === 'html' ) {
                //get result
                setCurrentOutputExclude(false);
                axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_API_ENDPOINT_RESULT, {
                    headers: {
                        //'Access-Control-Allow-Origin': '*',
                    },
                    params: {
                        custom: process.env.REACT_APP_API_CUSTOM,
                        inputs: [currentSubfloorID, currentCoveringID],
                        filters: [currentOptionID],
                        area: currentArea,
                        height: currentfiller,
                        suffix: currSuffix,
                        locale: currLocale
                    }
                }).then((response) => {
                    setCurrentOutput(response.data);
                    scrollFrame(['contInfo', 'inputsSet']);
                }).catch(function (error) {
                    console.log("BASEURL: " + process.env.REACT_APP_BASEURL);
                    console.log("API_ENDPOINT_RESULT: " + process.env.REACT_APP_API_ENDPOINT_RESULT);
                });

            } else if( mode === 'pdf' ) {

                const pdfParams = new URLSearchParams();
                pdfParams.append('custom', process.env.REACT_APP_API_CUSTOM);
                pdfParams.append('inputs[]', currentSubfloorID);
                pdfParams.append('inputs[]', currentCoveringID);
                pdfParams.append('filters[]', currentOptionID);
                pdfParams.append('area', currentArea);
                pdfParams.append('height', currentfiller);
                pdfParams.append('suffix', currSuffix);
                pdfParams.append('locale', currLocale);

                const pdfURL = process.env.REACT_APP_BASEURL + process.env.REACT_APP_API_ENDPOINT_PDF + pdfParams.toString();
                window.open(pdfURL, '_blank', 'noreferrer');
            }

        }

    }

    function getNameToIndex( index ) {
        var itemTemp = navigatorInputs.filter(inputElement => (parseInt(inputElement.id) === index));
        return itemTemp[0].name;

    }

    function scrollFrame( containerId = [], mode = 'top') {

        setTimeout(() => {

            if( mode === 'more' ) {
                const element = document.getElementById(containerId[1]);
                scroll.scrollMore(element.offsetHeight + 100, {
                    smooth: 'linear',
                    duration: 150,
                })
            } else {
                const element = document.getElementById(containerId[0]);
                scroll.scrollTo(element.offsetTop, {
                    smooth: 'linear',
                    duration: 150,
                })
            }

        }, 1500)

        //https://www.npmjs.com/package/react-scroll
    }

    function iframeResize() {
        window.setTimeout(iframeResizeRun, 1000);
     }

     function iframeResizeRun() {
         let height = document.getElementById('root').offsetHeight; // IMPORTANT: If body's height is set to 100% with CSS this will not work.
         window.parent.postMessage("resize::"+height,"*");
         //console.log('Resize: ' + height);
         //parent.postMessage("resize::"+height,"*");

         window.setTimeout(iframeResizeRun, 1000);
     }

    const imagesBG = {
        64: 'navigator_item_step_6.jpg',
        15: 'navigator_item_new_subfloors.jpg',
        29: 'navigator_item_textile_floor_coverings.jpg',
        41: 'navigator_item_resilient_coverings.jpg',
        51: 'navigator_item_wood_flooring.jpg' ,
        3 : 'navigator_item_standard.jpg' ,
        4 : 'navigator_item_fast_installation.jpg' ,
        5 : 'navigator_item_heavy_duty.jpg' ,
    };

    function getBGImage( id ){
        if(imagesBG[parseInt(id)] !== undefined) {
            return imagesBG[id];
        } else {
            return 'navigator_item_step_6.jpg';
        }
    }

    return (
        <>
            <Container className={ (process.env.REACT_APP_CONTAINER_FULLWIDTH === "true"? 'clearfullwidth':'') }>

                <h1>{ t('choose_type_subfloor') }</h1>
                <div id={'uu-cards-undercat'} className={"uu-cards switchtec-container"}>
                    <div className={"row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3"}>
                        {subfloorCategories.map(filteredInputs => (
                                <TileBig
                                    key={filteredInputs.id}
                                    id={filteredInputs.id}
                                    src={getBGImage(filteredInputs.id)}
                                    setCurrentItem={selectSubfloorCat}
                                    exclusiveTile={currentSubfloorCatID}
                                    clicktValue={filteredInputs.id}
                                >{filteredInputs.name}</TileBig>
                            ))
                        }
                    </div>
                </div>

                {currentSubfloorCatID > 0 &&
                    <div className={"entry-container"}>

                        <h2 id={'contUntergrund'} name={'contUntergrund'}>{ t('choose_subfloor') }:</h2>
                        <div id={'uu-cards-under'} className={"uu-cards"}>
                            <div className={"row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3"}>
                                {subfloorItems.map(filteredInputs => (
                                    <Tile
                                        key={filteredInputs.id}
                                        id={filteredInputs.id}
                                        setCurrentItem={selectSubfloorID}
                                        exclusiveTile={currentSubfloorID}
                                        clicktValue={filteredInputs.parent_id}
                                    >{filteredInputs.name}</Tile>
                                ))}
                            </div>
                        </div>
                    </div>
                }

                {currentSubfloorID > 0 &&
                    <>
                        <h1 id={'contBelagCat'}>{ t('choose_type_flooring') }</h1>
                        <div id={'uu-cards-floorcat'} className={"uu-cards switchtec-container"}>
                            <div className={"row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3"}>
                            {coveringCategories.map(filteredInputs => (
                                <TileBig
                                    key={filteredInputs.id}
                                    id={filteredInputs.id}
                                    src={getBGImage(filteredInputs.id)}
                                    setCurrentItem={selectCoveringCat}
                                    exclusiveTile={currentCoveringCatID}
                                    clicktValue={filteredInputs.id}
                                >{filteredInputs.name}</TileBig>
                            ))}
                            </div>
                        </div>

                        {currentCoveringCatID > 0 &&
                            <div className={"entry-container"}>
                                <h2 id={"contBelag"}>{ t('choose_flooring') }:</h2>
                                <div id={'uu-cards-floor'} className={"uu-cards"}>
                                    <div className={"row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3"}>
                                        { coveringItems.map(filteredInputs => (
                                            <Tile
                                                key={filteredInputs.id}
                                                id={filteredInputs.id}
                                                setCurrentItem={selectCoveringID}
                                                exclusiveTile={currentCoveringID}
                                                clicktValue = {filteredInputs.id}
                                            >{filteredInputs.name}</Tile>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                }

                {currentCoveringID > 0 &&
                    <div className={"entry-container"}>
                        <h2 id={'contOptions'}>{ t('specialfeatures') }:</h2>
                        <div id={'uu-cards-options'} className={"uu-cards"}>
                            <div className={"row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3"}>
                                <Tile
                                    key={"opt_3"}
                                    id={"3"}
                                    src={getBGImage(3)}
                                    setCurrentItem={resetOption}
                                    exclusiveTile={currentOptionID}
                                    clicktValue = {3}
                                >{t("Standard")}</Tile>
                                <Tile
                                    key={"opt_4"}
                                    id={"4"}
                                    src={getBGImage(4)}
                                    setCurrentItem={resetOption}
                                    exclusiveTile={currentOptionID}
                                    clicktValue = {4}
                                >{t("Schnellbau")}</Tile>
                                <Tile
                                    key={"opt_5"}
                                    id={"5"}
                                    src={getBGImage(5)}
                                    setCurrentItem={resetOption}
                                    exclusiveTile={currentOptionID}
                                    clicktValue = {5}
                                >{t("StarkeBelastung")}</Tile>
                            </div>
                        </div>
                    </div>
                }

                {currentOptionID > 0 &&
                    <div id={'inputsSet'} className={"entry-container"}>
                        <Row>
                                <h2 id={'contCreate'} className={"header header-input"}>{ t('filler_thikness') }:</h2>
                                <InputGroup className="mb-3 mb-bottom input-group-space">

                                    <Form.Control
                                        placeholder="Fläche"
                                        aria-label="Fläche"
                                        value={currentArea}
                                        onChange={event => resetInputValues(event.target.value, 'area')}
                                        aria-describedby="basic-addon2"
                                    />
                                    <InputGroup.Text id="basic-addon1">m²</InputGroup.Text>

                                    <div className="uu-formspacer">&nbsp;</div>

                                    <Form.Control
                                        placeholder="Spachtelmasse Schichtdicke"
                                        aria-label="Spachtelmase"
                                        value={currentfiller}
                                        pattern='[0-9]*'
                                        type='number'
                                        min='1'
                                        max='10'
                                        onChange={event => resetInputValues(event.target.value, 'thikness')}
                                        aria-describedby="basic-addon2"
                                    />
                                    <InputGroup.Text id="basic-addon2">mm</InputGroup.Text>

                                </InputGroup>
                        </Row>
                    </div>
                }

                { currentOptionID > 0 && currentOutput === '' &&
                    <div id={'uu-cards-btn'} className={"uu-cards switchtec-container uu-card-buttoncont entry-container"}>
                        <div className={"row uu-card-buttoncont"}>
                            <div className={'col'}>
                                <div className={'resultHtml'}
                                     dangerouslySetInnerHTML={{__html: t('InfoSubmitText')}}></div>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={'col'}>
                                <Button variant="primary" size="lg"
                                        onClick={() => onsubmit('html')}>{t('calculate')}</Button>
                            </div>
                        </div>
                    </div>
                }

                {currentOptionID > 0 && currentOutput === '' && currentOutputExclude &&
                            <Alert id={'contInfo'} variant={'warning'} className={'topMargin uuInfoBox'}>
                            <FontAwesomeIcon icon={faInfoCircle} className={'infoIcon'} />
                        <div>
                            <div className={'resultHtml'} dangerouslySetInnerHTML={{ __html: t('special_combination')}}></div>
                        </div>
                    </Alert>
                }


                { currentOutput !== '' &&
                    <Alert id={'contInfo'} variant={'info'} className={'topMargin uuInfoBox'}>
                        <FontAwesomeIcon icon={faInfoCircle} className={'infoIcon'} />
                        <div>
                            { t('resultbase') }:
                            <br /><strong><div className={'resultHtml'} dangerouslySetInnerHTML={{ __html: (getNameToIndex(currentSubfloorID) + ' - ' + getNameToIndex(currentCoveringID)) }}></div></strong>
                        </div>
                    </Alert>
                }


                { currentOptionID > 0 &&
                    <div id={'uu-cards-result'} className={"uu-cards switchtec-container result-container"}>
                        <div className={"row"}>
                            <div className={'col'}>
                                <div className={'resultHtml'} dangerouslySetInnerHTML={{ __html: currentOutput }}></div>
                            </div>
                        </div>
                    </div>
                }


                { currentOptionID > 0 && currentOutput !== '' &&
                    <div id={'uu-cards-btn'} className={"uu-cards switchtec-container uu-card-buttoncont"}>
                        <div className={"row"}>
                            <div className={'col'}>
                                <Button variant="primary" size="lg" onClick={() => onsubmit('pdf')}>{ t('pdf_download') }</Button>
                            </div>
                        </div>
                    </div>
                }

            </Container>

        </>


    );
}